import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from "styled-components";
import { THEME } from 'Util/constants';
import { UnorderedListOutlined, AppstoreOutlined } from '@ant-design/icons';
import { IconShare } from 'Components/Icons';
import { useRecoilState } from 'recoil';
import { listOrderAtom, selectedSpecies} from 'Store/procurementAtom';
import CommonExportIcon from 'Components/CommonExportIcon'
import InfoBoxSwitch from 'Components/InfoBoxSwitch'

const Container = styled.div`
    
    width: ${props => props.state === 'list' ? '55px' : '35px'};
    display: flex;
    justify-content: space-between;
    align-items: center;

    .anticon{
        color: ${THEME.colors.primary};
        cursor: pointer;
    }
    
    svg{
        cursor: pointer;
    }

`;

function ExtraFilters(props) {
    const [state, setState] = useRecoilState(listOrderAtom)
    const [species, setSelectedSpecies] = useRecoilState(selectedSpecies);

    const changeOrder = () => {
        setSelectedSpecies({})
        if(state === 'list') setState('grid')
        else setState('list')
    }
    const resetSelection = () => {
        setSelectedSpecies({})
    }

    return (
        <Container state={state}>
            <CommonExportIcon data={props.data} columns={props.columns}/>
            {state === 'list' ?
            <UnorderedListOutlined onClick={changeOrder}/>:
            <AppstoreOutlined onClick={changeOrder}/>
            }
            {state === 'list' && <InfoBoxSwitch origin='species' resetSelection={resetSelection}/>}
        </Container>
    )
}

ExtraFilters.propTypes = {}

export default ExtraFilters